import styled from 'styled-components'

const Container = styled.div`
  max-width: 1064px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
`

export default Container
